<template>
  <div class="v-manager">
    <Header/>
    <v-main :key="`update-on-settings-change-${settings.reportingSimpleView}-${settings.defaultActivityType}`">
      <router-view v-if="isSettingsLoaded"></router-view>
    </v-main>
  </div>
</template>

<script>
import { getApiErrorMessage } from '@/utils/apiError'

export default {
  name: 'Manager',
  components: {
    Header: () => import('@/components/global/Header.vue')
  },
  data () {
    return {
      isSettingsLoaded: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    settings () {
      return this.$store.getters.getSettings
    }
  },
  async mounted () {
    await this.getRoles()
    this.getSettings()
    this.getEmployee()
  },
  methods: {
    getEmployee () {
      this.axios.get('/api/employee', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.setEmployeeList(0, res.data)
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    setEmployeeList (beginNumber, employee) {
      const empl = []
      for (let i = beginNumber; i < beginNumber + 100; i++) {
        if (employee[i]) {
          empl.push(employee[i])
        } else {
          break
        }
      }

      if (empl.length) {
        this.$store.dispatch('addEmployee', { employee: empl })
      }

      if (empl.length === 100) {
        setTimeout(() => {
          this.setEmployeeList(beginNumber + 100, employee)
        })
      }
    },
    async getRoles () {
      this.axios.get('/api/employee_role/' + this.user.login, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.$store.dispatch('setEmployeeRoles', { roles: result.data })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getSettings () {
      this.axios.get('/api/activity_types', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setActivityTypes', { activityTypes: response.data })
        return this.axios.get('/api/settings', {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(response => {
          if (response.data) {
            this.$store.dispatch('setSettings', { settings: response.data })
          } else {
            return this.axios.put('/api/settings', { Settings: this.settings }, {
              headers: {
                Authorization: 'Bearer ' + this.user.token
              }
            }).catch(err => {
              const errorMsg = getApiErrorMessage(err)
              this.$store.dispatch('setError', { errorMsg })
            })
          }
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      }).finally(() => {
        this.isSettingsLoaded = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-manager {
    padding-top: 50px;
  }
</style>
